import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {RouterProvider} from 'react-router-dom';
import {Amplify} from 'aws-amplify';
import {router} from "./app/router/Routes";
import {StoreProvider} from "./infrastructure/store/store";
import {API_CONFIG, AUTH_CONFIG} from "./shared/amplify/amplify-utils";

import 'react-toastify/dist/ReactToastify.min.css';
import 'semantic-ui-css/semantic.min.css';
import '../src/assets/css/style.css';

Amplify.configure({Auth: AUTH_CONFIG, API: API_CONFIG});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <StoreProvider>
      <RouterProvider router={router} />
    </StoreProvider>
);

reportWebVitals();
